import { render, staticRenderFns } from "./CardsTitle.vue?vue&type=template&id=419768de"
import script from "./CardsTitle.vue?vue&type=script&lang=ts"
export * from "./CardsTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('419768de')) {
      api.createRecord('419768de', component.options)
    } else {
      api.reload('419768de', component.options)
    }
    module.hot.accept("./CardsTitle.vue?vue&type=template&id=419768de", function () {
      api.rerender('419768de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/payment/prices/CardsTitle.vue"
export default component.exports